// extracted by mini-css-extract-plugin
export default {"collapse":"collapse__n3cVZ7"};